var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuilding2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "building2-filled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    fill: "#093a5b",
    transform: "translate(42.666667, 64.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.666667,1.42108547e-14 L234.666,341.333 L256,341.333 L256,85.3333333 L405.333333,85.3333333 L405.333,341.333 L426.666667,341.333333 L426.666667,384 L234.666,383.999 L234.666667,384 L21.3333333,384 L21.333,383.999 L7.10542736e-15,384 L7.10542736e-15,341.333333 L21.333,341.333 L21.3333333,1.42108547e-14 L234.666667,1.42108547e-14 Z M149.333333,277.333333 L106.666667,277.333333 L106.666667,341.333333 L149.333333,341.333333 L149.333333,277.333333 Z M341.333333,256 L298.666667,256 L298.666667,298.666667 L341.333333,298.666667 L341.333333,256 Z M341.333333,170.666667 L298.666667,170.666667 L298.666667,213.333333 L341.333333,213.333333 L341.333333,170.666667 Z M149.333333,170.666667 L106.666667,170.666667 L106.666667,213.333333 L149.333333,213.333333 L149.333333,170.666667 Z M149.333333,85.3333333 L106.666667,85.3333333 L106.666667,128 L149.333333,128 L149.333333,85.3333333 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding2);
export default __webpack_public_path__ + "static/media/building2.9a048dfdc801fce4504fe5119a975d30.svg";
export { ForwardRef as ReactComponent };